//
// Single point of contact for Vue
//
// TODO:
//   Conditionally import Vue if no global Vue
//
import Vue from 'vue';
export default Vue;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_bootstrap-vue@2.6.1@bootstrap-vue/esm/utils/vue.js
// module id = null
// module chunks = 